import { render, staticRenderFns } from "./collectionsTable.vue?vue&type=template&id=ae49e2ae&"
import script from "./collectionsTable.vue?vue&type=script&lang=js&"
export * from "./collectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./collectionsTable.vue?vue&type=style&index=0&id=ae49e2ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports